import { Link } from "wouter";
import { Facebook, Instagram, Linkedin, Clock } from "lucide-react";
import { MapPin } from "lucide-react";
import { analyticsEvents, trackEvent } from "@/lib/ga4";
// Using placeholder logos for certifications - replace with actual working URLs
const iataLogo = 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=50&fit=crop';
const taaiLogo = 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=50&fit=crop';
const iatoLogo = 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=50&fit=crop';
const rbiLogo = 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=50&fit=crop';
const visaLogo = 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=50&fit=crop';

export default function Footer() {
  const recordOutbound = (itemName: string, url: string) => {
    const pagePath =
      typeof window !== "undefined" ? window.location.pathname : "/footer";
    trackEvent({
      name: analyticsEvents.outboundClick,
      params: {
        content_type: "social",
        item_id: itemName,
        item_name: itemName,
        destination_url: url,
        page_type: "footer",
        page_path: pagePath,
      },
    });
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <img
                src="/logo.png"
                alt="Travel Wings Forex Private Limited"
                width={160}
                height={48}
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-gray-300 mb-2 text-sm italic">
              Formerly known as Make My Travel (India) Pvt. Ltd.
            </p>
            <p className="text-gray-300 mb-4 leading-relaxed text-sm">
              Travel Wings Forex Pvt Ltd was established in 2010 and is a leading corporate travel company dedicated to providing cost-effective, luxurious, excellent personalized travel solutions and ancillary services. We are recognized by various travel associations such as IATA, Ministry of Tourism, Govt. of India, IATO, TAAI, and TAAFI. We are an RBI-approved AD II Category License holder authorized to deal with foreign currency.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/Travelwingsforex/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Travel Wings on Facebook"
                className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-md text-gray-300 hover:text-white transition-colors"
                onClick={() =>
                  recordOutbound(
                    "facebook",
                    "https://www.facebook.com/Travelwingsforex/"
                  )
                }
              >
                <Facebook className="w-5 h-5" aria-hidden />
              </a>
              <a
                href="https://www.instagram.com/travelwingsforex1/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Travel Wings on Instagram"
                className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-md text-gray-300 hover:text-white transition-colors"
                onClick={() =>
                  recordOutbound(
                    "instagram",
                    "https://www.instagram.com/travelwingsforex1/"
                  )
                }
              >
                <Instagram className="w-5 h-5" aria-hidden />
              </a>
              <a
                href="https://www.linkedin.com/company/travel-wings-forex-private-limted/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Travel Wings on LinkedIn"
                className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-md text-gray-300 hover:text-white transition-colors"
                onClick={() =>
                  recordOutbound(
                    "linkedin",
                    "https://www.linkedin.com/company/travel-wings-forex-private-limted/"
                  )
                }
              >
                <Linkedin className="w-5 h-5" aria-hidden />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/packages"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Packages
                </Link>
              </li>
              <li>
                <Link
                  to="/team"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Our Team
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/live-rates"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Currency Exchange
                </Link>
              </li>
              <li>
                <Link
                  to="/packages"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Holiday Packages
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Forex Cards
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Travel Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Visa Services
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className="text-gray-200 hover:text-white transition-colors"
                >
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Corporate Addresses</h4>
            <div className="space-y-4 text-gray-300">
              <div className="flex items-start">
                <MapPin className="w-4 h-4 mr-3 text-yellow-400 flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <p className="font-medium">Main Office:</p>
                  <p>105, 1st Floor, Pocket-B Market, Sarita Vihar, New Delhi-110076</p>
                  <p>Tel: 011-41616942, 011-41716942, 011-42860239</p>
                  <p>Mobile: +91 88826 40963, +91 98108 52274</p>
                </div>
              </div>
              <div className="flex items-start">
                <MapPin className="w-4 h-4 mr-3 text-yellow-400 flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <p className="font-medium">Branch Office:</p>
                  <p>2-P&2-F, 2nd Floor, DCM Building, 16 Barakhamba Road, New Delhi-110001</p>
                  <p>Tel: 011-49983453</p>
                </div>
              </div>
              <div className="flex items-start">
                <MapPin className="w-4 h-4 mr-3 text-yellow-400 flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <p className="font-medium">Branch Office:</p>
                  <p>C-28, Shop#5, Masoodpur, Vasant Kunj, New Delhi-110070</p>
                  <p>Tel: 011-46048710</p>
                  <p>Mobile: +91 9582700184</p>
                  <p>+91 95827 00912</p>
                </div>
              </div>
              <div className="flex items-center">
                <Clock className="w-4 h-4 mr-3 text-yellow-400 flex-shrink-0" />
                <p className="text-sm">Mon-Sat (10:00 AM - 6:00 PM)</p>
              </div>
            </div>
          </div>
        </div>

        {/* Associations & Recognitions */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="text-center mb-6">
            <h3 className="text-lg font-semibold text-white mb-4">Associations & Recognitions</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
              <div className="bg-white p-2 rounded-lg shadow-md hover:shadow-lg transition-shadow flex items-center justify-center h-20 group cursor-pointer">
                <img
                  src="/associations/iata-logo.png"
                  alt="IATA - International Air Transport Association"
                  width={160}
                  height={64}
                  className="max-h-16 max-w-full object-contain group-hover:scale-105 transition-transform"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.parentElement!.innerHTML = '<div class="text-center"><div class="text-xs font-bold text-blue-600">IATA</div><div class="text-xs text-gray-500">Certified</div></div>';
                  }}
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md hover:shadow-lg transition-shadow flex items-center justify-center h-20 group cursor-pointer">
                <img 
                  src="/associations/taai-logo.png" 
                  alt="TAAI - Travel Agents Association of India" 
                  className="max-h-16 max-w-full object-contain group-hover:scale-105 transition-transform brightness-150 contrast-150 saturate-150"
                  style={{ 
                    filter: 'brightness(1.5) contrast(1.5) saturate(1.5)',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '4px',
                    padding: '2px'
                  }}
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.parentElement!.innerHTML = '<div class="text-center"><div class="text-xs font-bold text-red-600">TAAI</div><div class="text-xs text-gray-500">Member</div></div>';
                  }}
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md hover:shadow-lg transition-shadow flex items-center justify-center h-20 group cursor-pointer">
                <img
                  src="/associations/iato-logo.png"
                  alt="IATO - Indian Association of Tour Operators"
                  width={160}
                  height={64}
                  className="max-h-16 max-w-full object-contain group-hover:scale-105 transition-transform"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.parentElement!.innerHTML = '<div class="text-center"><div class="text-xs font-bold text-green-600">IATO</div><div class="text-xs text-gray-500">Member</div></div>';
                  }}
                />
              </div>
              <div className="bg-white p-2 rounded-lg shadow-md hover:shadow-lg transition-shadow flex items-center justify-center h-20 group cursor-pointer">
                <img
                  src="/associations/ministry-tourism-logo.png"
                  alt="Ministry of Tourism Approval"
                  width={160}
                  height={64}
                  className="max-h-16 max-w-full object-contain group-hover:scale-105 transition-transform"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.parentElement!.innerHTML = '<div class="text-center"><div class="text-xs font-bold text-orange-600">MINISTRY</div><div class="text-xs text-gray-500">Approved</div></div>';
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-4 pt-6 text-center">
          <p className="text-gray-400">
            &copy; 2026 Travel Wings Forex Private Limited. All rights reserved. |
            <Link to="/privacy-policy" className="text-gray-200 hover:text-white transition-colors ml-1 mr-1">Privacy Policy</Link> | 
            <Link to="/terms-of-service" className="text-gray-200 hover:text-white transition-colors ml-1">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}